import type { ModelPaymentAccount } from '@app/api/PaymentAccounts';
import type { AUTH_SERVER_UNAVAILABLE, ERROR, WARNING } from '@app/constants';
import type {
  NAuth,
  NEmployees,
  NRecords,
  TModelRecordReceipt,
  NOrganization,
} from '@app/types';

/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: здесь тип Any планируется убрать отдельным этапом в рамках task/3444,
// т.к. у нас завязано 74 места в кодовой базе на конфиг axios (CreateServerRequest)

export namespace NServices {
  export interface TypicalArgs {
    userId: NAuth.UserPrint['userId'];
    database: NAuth.UserPrint['database'];
    activeBranchId: NAuth.UserPrint['activeBranchId'];
  }

  export interface TypicalArgsAsOneObject {
    userPrint: NAuth.UserPrint;
  }

  export type CreateServerRequest = (
    axiosConfig: any,
    logs?: {
      isLogged: boolean;
      userId: NAuth.User['userId'];
      database: NAuth.User['database'];
    }
  ) => any;

  export type ApiResult = {
    Success: boolean;
    ErrorMessage: string | null;
    JsonData: string | null;
    FileData: string | null;
  };

  export type ServerRequestError =
    | string
    | {
        message: string;
        cause: typeof WARNING | typeof ERROR;
      };

  export type RedirectToAuthorization = () => Promise<
    NAuth.ModelAuthentication | 'navigation' | typeof AUTH_SERVER_UNAVAILABLE
  >;

  export type GetCaptcha = (args: {
    setServerError: SetServerError;
    setCaptchaImage: SetCaptchaImage;
    setRightCaptchaValue: SetCaptchaRightResult;
  }) => Promise<void>;

  export type DecryptEmailCookie = (args: {
    emailCookie?: string;
  }) => Promise<string>;

  export type SetServerError = (error: string) => void;

  export type SetCaptchaImage = (image: string) => void;

  export type SetCaptchaRightResult = (value: string) => void;

  export type GetUserPositions = (
    args: {
      setPositions: (positions: Array<string>) => void;
    } & TypicalArgs
  ) => Array<string> | Promise<Array<string>>;

  export type SetChains = (chains: []) => void;

  export type SetBranches = (branches: []) => void;

  export type SendDataToDb<T> = (args: {
    data: T;
    submitType: string;
  }) => Promise<unknown>;

  export type ModelClientServiceFilter = {
    ActiveBranchId: NAuth.UserPrint['activeBranchId'];
    data: {
      SearchTerm: string | null;
      CategoryIds: number[] | null;
      BranchIds: number[] | null;
    };
  };

  export type GetBranchEmployeesOrder = (args: {
    activeBranchId: NAuth.UserPrint['activeBranchId'];
  }) => Promise<NEmployees.ModelBranchEmployeesOrder>;

  export type SetBranchEmployeesOrder = (args: {
    activeBranchId: NAuth.UserPrint['activeBranchId'];
    requestModel: NEmployees.ModelOrderIndex[];
  }) => Promise<void>;

  export interface PrepareRecordCreationHandlerProps {
    employeeId: number;
    dateTime: string;
    recordId?: number;
  }

  export interface CheckRecordTimesProps {
    recordId: number | null;
    employeeId: number | null;
    branchId: number | null;
    timeS: string;
    timeE: string;
  }

  export type ArgsToPrepayRecord = {
    activeBranchId: TypicalArgs['activeBranchId'];
    recordId: NRecords.ClientRecord['Id'];
    accountId: ModelPaymentAccount['Id'];
    amount: number;
    paymentDate?: string;
    comment?: string;
  };

  export type PrepayRecord = (
    args: ArgsToPrepayRecord
  ) => Promise<TModelRecordReceipt>;

  export type GetAiParams = {
    ActiveBranchId: NAuth.UserPrint['activeBranchId'];
  };

  export type GetAi = (
    args: GetAiParams
  ) => NOrganization.OrganizationUserIdDto[];
}
